import { Row, Col, Image } from 'react-bootstrap';


function Ansprechpartner({name, position, phone, mail, picture}) {
    const imageLink = picture ? picture : 'icon_man_men_placeholder.svg';
    return (
        <Row>
            <Col className='ansprechpartner text-center'>
                <Image src={imageLink} className='rounded-circle' height="85px" width="85px"/>
                <h2>{name}</h2>
                <small>{position}</small>
                <p><a className='phone' href={"tel:"+phone}>{phone}</a><br/><a href={"mailto:" + mail}>{mail}</a></p>
            </Col>
        </Row>
    );
}

export default Ansprechpartner;